__turbopack_context__.v({
  "count": "SearchPage-module-scss-module__24CnjW__count",
  "empty": "SearchPage-module-scss-module__24CnjW__empty",
  "header": "SearchPage-module-scss-module__24CnjW__header",
  "title": "SearchPage-module-scss-module__24CnjW__title",
});
